import styled from "styled-components";
import { Headline, Paragraph } from "../Text";

export const FormContainer = styled.form`
  display: flex;
  margin-top: 60px;
`;

export const FormLabel = styled(Paragraph)`
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  color: #170f49;
  margin-bottom: 5px;
`;

export const InputLabel = styled.label`
  display: flex;
  margin-bottom: 12px;
  width: 100%;
  span {
    font-size: 16px;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
`;

export const Input = styled.input`
  padding: 8px;

  font-size: 16px;
  border: 1px solid #eff0f7;
  /* Input/Default */
  flex: 40%;
  box-shadow: 0px 2px 6px rgba(19, 18, 66, 0.07);
  border-radius: 46px;
  color: #6f6c90;
  box-sizing: border-box;
  padding: 18px 22px;
`;

export const FormHeadline = styled(Headline)`
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  text-align: left;
`;

export const FormParagraph = styled(Paragraph)`
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
`;
